import React, { useEffect, useState, useRef } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { content } from '../mockData';

const RevenueModelSection = () => {
  const { language } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const revenueContent = content[language].revenueModel;

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.15 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section 
      id="revenue" 
      ref={sectionRef}
      className="section"
      style={{ background: '#ffffff' }}
    >
      <div className="container">
        {/* Header */}
        <div className={`text-center mb-80 fade-in-up ${isVisible ? 'visible' : ''}`}>
          <h2 className="mb-32">{revenueContent.title}</h2>
          <p style={{ maxWidth: '800px', margin: '0 auto' }}>
            {revenueContent.intro}
          </p>
        </div>

        {/* Revenue Streams */}
        <div className="grid-2" style={{ gap: '60px' }}>
          {revenueContent.streams.map((stream, index) => (
            <div
              key={stream.title}
              className={`fade-in-up ${isVisible ? 'visible' : ''}`}
              style={{
                padding: '48px 40px',
                background: 'var(--ivory)',
                transitionDelay: `${index * 0.15}s`
              }}
            >
              <h3 
                className="mb-32" 
                style={{ 
                  fontSize: '1.5rem',
                  color: 'var(--olive)',
                  fontWeight: 500
                }}
              >
                {stream.title}
              </h3>
              
              {stream.description && (
                <p style={{
                  fontSize: '0.9375rem',
                  marginBottom: '32px',
                  lineHeight: 1.8,
                  color: '#4a4a4a'
                }}>
                  {stream.description}
                </p>
              )}
              
              <ul style={{ 
                listStyle: 'none',
                padding: 0,
                margin: 0
              }}>
                {stream.items.map((item) => (
                  <li
                    key={item}
                    style={{
                      marginBottom: '16px',
                      paddingLeft: '24px',
                      position: 'relative',
                      fontSize: '0.9375rem',
                      color: '#4a4a4a'
                    }}
                  >
                    <span
                      style={{
                        position: 'absolute',
                        left: 0,
                        top: '8px',
                        width: '6px',
                        height: '6px',
                        background: 'var(--gold)',
                        borderRadius: '50%'
                      }}
                    />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RevenueModelSection;
